module.exports = __webpack_public_path__ + "static/media/suit-4.369298a4.jpg";